export type OnErrorType = (e: unknown) => void

export enum CommentsTypeEnum {
  Community = 'community',
  Page = 'page',
  LightLecture = 'light_lecture',
}

export const CommentSortOptions = {
  NEWEST_FIRST: 'newest_first',
  OLDEST_FIRST: 'oldest_first',
  POPULAR: 'popular',
} as const

export type CommentSortEnum = (typeof CommentSortOptions)[keyof typeof CommentSortOptions]

export enum AuthorRoleEnum {
  Admin = 'admin',
  Owner = 'owner',
  Moderator = 'assistant',
}

export enum EditorMode {
  Add = 'ADD',
  Edit = 'EDIT',
}
